import React from 'react';
import styled from '@emotion/styled';
import { Box, Paper } from '@mui/material';
import Data from '../Data/PersonalInfo.json';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#f2f2f2',
  ...theme.typography.body2,
  padding: theme.spacing(3),
  textAlign: 'center',
  color: theme.palette.text.secondary,
  width: '130px',
  height: '130px',
  opacity: 1,
}));

// @desc Skills
const TechStack = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center',
        rowGap: '10px',
        columnGap: '10px',
        height: 'auto',
        padding: '20px',
      }}
    >
      {Data.techStack.map(({ name, image }) => (
        <Item key={name}>
          <img src={image} alt={name} width={64} height={64} />
          <h4>{name}</h4>
        </Item>
      ))}
    </Box>
  );
};

export default TechStack;
